module.exports = __webpack_public_path__ + "4fa4e420f3a61a5b54343a52d7f7d46c.png";